(function () {
  function initBar(el) {
    const thresholds = JSON.parse(el.dataset.thresholds || "{}");
    const total = parseInt(el.dataset.initialTotal || "0", 10);
    const belowText =
      el.dataset.belowText || "Spend {amount} more to get free shipping";
    const achievedText = el.dataset.achievedText || "You've got free shipping!";

    const currency = window.Shopify?.currency?.active || "USD";
    const threshold = (thresholds[currency] || 0) * 100;

    if (threshold <= 0) {
      el.style.display = "none";
      return;
    }

    el.style.display = "";

    const remaining = Math.max(0, threshold - total);
    const progress = Math.min(100, Math.round((total / threshold) * 100));
    const achieved = total >= threshold;

    const fillEl = el.querySelector(".fss-bar__fill");
    const msgEl = el.querySelector(".fss-bar__message");

    if (fillEl) fillEl.style.width = progress + "%";

    if (msgEl) {
      if (achieved) {
        msgEl.textContent = achievedText;
      } else {
        let formatted;
        try {
          formatted = new Intl.NumberFormat(undefined, {
            style: "currency",
            currency,
            minimumFractionDigits: 0,
            maximumFractionDigits: 0,
          }).format(remaining / 100);
        } catch (_) {
          formatted = Math.round(remaining / 100) + " " + currency;
        }
        msgEl.textContent = belowText.replace("{amount}", formatted);
      }
    }
  }

  function initAllBars() {
    document.querySelectorAll(".fss-bar").forEach(initBar);
  }

  function setup() {
    initAllBars();
    if (
      typeof subscribe === "function" &&
      typeof PUB_SUB_EVENTS !== "undefined"
    ) {
      subscribe(PUB_SUB_EVENTS.cartUpdate, () => setTimeout(initAllBars));
    }
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", setup);
  } else {
    setup();
  }
})();
